import Button from '@material-ui/core/Button'
import { withStyles } from '@material-ui/core/styles'
import Popup from 'Components/Popup'
import { QRCodeCanvas } from 'qrcode.react'
import React from 'react'
import styles from './styles'

const QRCodePopup = ({ content, onCancel, isOpen, classes }) => {
  if (!isOpen) {
    return null
  }

  return (
    <Popup
      title="QRCode"
      onCancel={onCancel}
      modalClassName={classes.qrCodePopup}
      showCross
      body={
        <div>
          <QRCodeCanvas value={content} />,
        </div>
      }
      footer={
        <div>
          <Button
            className={classes.button}
            variant="outlined"
            onClick={onCancel}
          >
            Close
          </Button>
        </div>
      }
    />
  )
}

export default withStyles(styles)(QRCodePopup)
